import React from 'react';
import moment from 'moment';

const Itinerary = ({ jobs, onTripSelect, isPhone }) => {
  return (
    <div
      id="itinerary"
      className="flex flex-col w-full"
      style={{ height: !isPhone ? '100%' : 'auto' }}
    >
      {jobs.map((job, index) => (
        <div
          key={`${job.jobNumber}-${job.type}-${index}`}
          className="w-full rounded overflow-hidden pl-1"
          onClick={() => !job.isBreak && onTripSelect(job.jobNumber)}
          style={{
             cursor: job.isBreak ? 'default' : 'pointer' }}
        >
          <div
            className="flex text-sm flex-col rounded overflow-hidden shadow-md m-1"
            style={{ 
              border: '1px solid lightgray', 
              borderBottom: '0px', 
              height: 'auto',
              backgroundColor: job.isBreak ? '#e0f2fe' : 'white' // Light blue for breaks, white for trips
            }}
          >
            <div className="flex w-full ">
              {job.type === 'Pickup' && (
                <div
                  className={`w-1`}
                  style={{ backgroundColor: job.wheelChair ? 'rgb(66 186 240)' : 'rgb(255 210 5)' }}
                />
              )}
              {job.type === 'Break' && (
                <div
                  className={`w-1`}
                  style={{ backgroundColor: 'rgb(3 169 244)' }} // Blue indicator for break
                />
              )}
              <div className="flex p-2 w-full">
                <p className="w-7/12 text-sm text-left">
                  <span className="block">
                    <span style={{fontSize:'14px'}}>{job.type}:</span> {job.paxName} 
                  </span>
                  {job.isBreak ? (
                    <span className="text-xs text-gray-600">
                      {job.startTime} - {job.endTime}
                    </span>
                  ) : (
                    job.address1
                  )}
                </p>
                <div className="w-5/12 text-sm text-right">
                  <div>
                    <span>{moment(job.time, 'hh:mm:ss A').format('HH:mm')}</span>
                    {!job.isBreak && (
                      <span className='text-xs'>{job.wheelChair ? ' - W/C' : ' - Amb'}</span>
                    )}
                  </div>
                  <div>
                    {job.etaDistance ?
                      `${job.etaDuration} mins - ${parseInt(job.etaDistance).toFixed(1)} mi` :
                      ''
                    }
                  </div>
                </div>
              </div>
              {job.type === 'Dropoff' && (
                <div
                  className={`w-1`}
                  style={{ backgroundColor: job.wheelChair ? 'rgb(66 186 240)' : 'rgb(255 210 5)' }}
                />
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Itinerary;
